'use strict';

angular.module('licensure.services')
    .factory('LicenseCategories', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategories', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategories/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_category) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecategories/';
                if (!isUndefined(license_category.id)) {
                    method = 'PUT'
                    url += license_category.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_category: license_category,
                        certification_fields: license_category.certification_fields
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            updateAllowMultipleLevels: function (license_category) {
                var d = $q.defer();

                var method = 'PUT';
                var url = apiLocation + '/api/licensecategories/updateAllowMultipleLevels/' + license_category.id;

                if (isUndefined(license_category.allow_multiple_levels) || license_category.allow_multiple_levels == null) {
                    license_category.allow_multiple_levels = false;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_category: license_category,
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;